import { onBeforeUnmount, onMounted, ref } from 'vue';
import { contentSessionEnded } from '../util/reading-session';

export function useContentSessionEnd() {
  const contentSessionHasEnded = ref(false);

  const endContentSession = () => {
    if (contentSessionHasEnded.value) {
      return;
    }
    contentSessionEnded();
    contentSessionHasEnded.value = true;
  };

  const registerSessionEndListeners = () => {
    // prefer pagehide to unload events
    // only register beforeunload/unload in browsers that don't support
    // pagehide to avoid breaking bfcache
    if ('onpagehide' in window.self) {
      window.addEventListener('pagehide', endContentSession, { capture: true });
    } else {
      window.addEventListener('unload', endContentSession, { capture: true });
      window.addEventListener('beforeunload', endContentSession, { capture: true });
    }
  };

  const cleanupSessionEndListeners = () => {
    if ('onpagehide' in window.self) {
      window.removeEventListener('pagehide', endContentSession, { capture: true });
    } else {
      window.removeEventListener('unload', endContentSession, { capture: true });
      window.removeEventListener('beforeunload', endContentSession, { capture: true });
    }
  };

  onMounted(() => {
    registerSessionEndListeners();
  });

  onBeforeUnmount(() => {
    cleanupSessionEndListeners();
  });

  return {
    endContentSession,
    contentSessionHasEnded,
  };
}
